import { User } from './types'

import _ from 'lodash'

export const loadingUser: User = _.assign({}, { loading: true }, { Username: 'Loading', Name: '', LastName: '', Role: '', HasAccess: false, EffectivePermissions: [], ResourcePermissions: [], AuthProviderType: '', Email: '', IsCodeToken: false, AcceptanceDone: false })

export const emptyUser: User = _.assign({}, { loading: false }, { Username: '', Name: '', LastName: '', Role: '', HasAccess: false, EffectivePermissions: [], ResourcePermissions: [], AuthProviderType: '', Email: '', IsCodeToken: false, AcceptanceDone: false })

export const blankSecurity = {
  error: false,
  currentUser: loadingUser,
}
